import React, {FC} from "react";
import {Card} from "react-bootstrap";
import {Field} from "formik";
import {FormikRowInput, FormikRowSelect} from "@components/panel/formik";
import {GoalConditionType} from "@interfaces/consumer/refs";

export interface GoalConditionFormValues {
    name: string;
    isActive: boolean;
    type: GoalConditionType;
    donateValue?: number;
}

interface ConditionBaseInfoBlockProps {
    editForm?: boolean;
}

const ConditionBaseInfoBlock: FC<ConditionBaseInfoBlockProps> = ({editForm}) => {
    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Основное</Card.Header>
            <Card.Body>
                <Field
                    label="Название"
                    name="name"
                    component={FormikRowInput}
                />

                <Field
                    label="Тип"
                    name="type"
                    component={FormikRowSelect}
                    disabled={editForm}
                >
                    <option value={GoalConditionType.Manual}>Через API</option>
                    <option value={GoalConditionType.Donate}>Сумма доната</option>
                    <option value={GoalConditionType.SignUp}>Регистрация</option>
                    <option value={GoalConditionType.SignUpRef}>Регистрация по приглашению</option>
                </Field>
            </Card.Body>
        </Card>
    );
};

export default ConditionBaseInfoBlock;
